// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"50e2d95d","1936":"48ea18a3","2020":"04e45ed1","3816":"92004fb7","3841":"6ba11658","6030":"92004fb7","9248":"48ea18a3","9380":"4233ae50"}[chunkId] + ".chunk.css";
};